import MuiInputAdornment, { InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material/InputAdornment';

export type InputAdornmentProps = MuiInputAdornmentProps;

export const InputAdornment = (props: InputAdornmentProps) => {
  return <MuiInputAdornment {...props} />;
};
